import { IconButton as Button, ButtonProps } from "@chakra-ui/react";
import styled from "@emotion/styled";
import React from "react";

import { ICON_BUTTONS_THEMES, IconButtonVariantType } from "./icon-button";

type Props = ButtonProps & {
  variant?: IconButtonVariantType;
  arialLabel?: string;
  icon: React.ReactElement;
  iconActiveColor?: string;
  iconDisabledColor?: string;
  fillColor?: string;
};

const StyledButton = styled((props) => <Button {...props} />)`
  path {
    fill: ${(props) => (props.disabled ? props.iconDisabledColor : props.fillColor)};
  }

  &:active {
    path {
      fill: ${(props) => (props.disabled ? props.iconDisabledColor : props.iconActiveColor)};
    }
  }
`;

export const OFIconButton = ({ variant = "primary", icon, arialLabel, ...props }: Props) => (
  <StyledButton
    aria-label={arialLabel}
    w="40px"
    h="40px"
    bg="transparent"
    borderRadius={8}
    boxShadow="none"
    _disabled={{
      _active: { bg: "transparent" },
      _hover: { bg: "transparent" }
    }}
    _focus={{ boxShadow: "none" }}
    icon={icon}
    {...ICON_BUTTONS_THEMES[variant]}
    {...props}
  />
);
